import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import SchoolCalendarReadPage from '../schoolCalendar/SchoolCalendarReadPage';
import { buildSchoolYearOptions } from '../common/schoolYear';
import { buildSearchWithSchoolYear, getNormalizedSchoolYearStartYearFromSearch } from '../manage/manageSchoolYearRouting';

export default function ClientSchoolCalendar({ contextKey }) {
  const history = useHistory();
  const location = useLocation();
  const year = getNormalizedSchoolYearStartYearFromSearch(location.search);
  const search = buildSearchWithSchoolYear('', year);
  useEffect(() => {
    if (search !== location.search) history.replace({ pathname: location.pathname, search });
  }, [history, location.pathname, location.search, search]);
  return (
    <div>
      <label htmlFor="client-calendar-year">
        Rok szkolny
        <select
          id="client-calendar-year"
          className="form-control mb-3"
          value={year}
          onChange={event => history.replace({ pathname: location.pathname, search: buildSearchWithSchoolYear('', Number(event.target.value)) })}
        >
          {buildSchoolYearOptions().map(option => <option key={option.value} value={option.value}>{option.text}</option>)}
        </select>
      </label>
      <SchoolCalendarReadPage schoolYearStart={year} contextKey={contextKey} />
    </div>
  );
}
ClientSchoolCalendar.propTypes = { contextKey: PropTypes.string.isRequired };
